import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Platform from 'platform';
import { isEmpty } from 'lodash';
import { CONTENT_TYPES } from 'constants/content-types';
import { navigateToPlayerPage } from 'actions/player';
import PLAYER_TYPES from 'constants/player-types';

const useResolveDeeplink = (history) => {
  const dispatch = useDispatch();
  // Deeplink format is {type:'movie|series|channel', id: int}
  const deeplinkInfo = Platform.deeplink;

  useEffect(() => {
    let pathname = '';
    if (!isEmpty(deeplinkInfo)) {
      if (deeplinkInfo.type === 'movie') {
        pathname = `/details/${CONTENT_TYPES.VOD_ASSET}/${deeplinkInfo.id}`;
      }

      if (deeplinkInfo.type === 'series') {
        pathname = `/details/${CONTENT_TYPES.TV_SERIES}/${deeplinkInfo.id}`;
      }

      if (deeplinkInfo.type === 'channel') {
        dispatch(
          navigateToPlayerPage({
            item: { id: deeplinkInfo.id },
            type: PLAYER_TYPES.CHANNEL,
          }),
        );
        return;
      }
    }
    // HACK! TODO: remove connected-router and replace with regular one.
    // This delay resolve bugs iwth back button after depp link resolving
    // If history.push will perform before all router componennets render
    // it causes bugs with history.length and back will close whole app
    if (pathname) setTimeout(() => history.push({ pathname, search: '?isDeepLink=true' }), 550);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useResolveDeeplink;
